package shared.model.common.domain

enum class Language {
    CS,
    SK,
    EN,
}
